<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('suppliers')">
      <v-menu offset-y
              left
              slot="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary"
                 outlined
                 v-bind="attrs"
                 v-on="on">
            {{ $t('actions') }}
            <v-icon right>ti-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-on:click="openSendDialog(null)">
            <v-list-item-icon class="mr-3"><v-icon>ti-mail-fast</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('sendEmail') }}</v-list-item-title>
          </v-list-item>
          <v-divider class="my-1" />
          <v-list-item v-on:click="exportSuppliers">
            <v-list-item-icon class="mr-3"><v-icon>ti-file-spreadsheet</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('export') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </top-header>
    <email-test-mode-banner />
    <v-progress-linear color="accent"
                       indeterminate
                       v-bind:active="loading" />
    <send-email-dialog audience="Supplier"
                       v-bind:recipient-ids="sendRecipientIds"
                       v-bind:recipient-label="sendRecipientLabel"
                       v-model="sendDialog"
                       v-on:created="onJobCreated" />
    <email-job-progress ref="jobProgress" />
    <div class="sf-container">
      <supplier-list v-bind:suppliers="suppliers"
                     v-on:send-email-message="sendIndividualEmailMessage" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import EmailJobProgress from '@/components/administration/EmailJobProgress'
  import EmailTestModeBanner from '@/components/administration/EmailTestModeBanner'
  import SendEmailDialog from '@/components/administration/SendEmailDialog'
  import SupplierList from '@/components/administration/SupplierList'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      EmailJobProgress,
      EmailTestModeBanner,
      SendEmailDialog,
      SupplierList,
      TopHeader
    },
    computed: {
      ...mapGetters([ 'suppliers', 'customEmailTemplates' ])
    },
    async created() {
      this.loading = true
      await this.$store.dispatch('loadCustomEmailTemplates')
      this.$store.dispatch('loadEmailDesignerData')
      await this.$store.dispatch('loadSuppliers')
      this.loading = false
    },
    data: () => ({
      loading: false,
      sendDialog: false,
      sendRecipientIds: null,
      sendRecipientLabel: null
    }),
    methods: {
      exportSuppliers() {
        let csv = '"Id","CompanyName","GivenName","FamilyName","StreetAddress","PostalCode","City","Email","Web","State","CountBoothStaff","CountTables","CountRegularOutlets","CountSpecialOutlets","CountDinnerAttendees","Comments","InvitationCode"\n'

        for (const supplier of this.suppliers) {
          csv += `"${supplier.id}","${supplier.companyName}","${supplier.givenName}","${supplier.familyName}","${supplier.streetAddress}","${supplier.postalCode}","${supplier.city}","${supplier.email}","${supplier.web}","${supplier.state}","${supplier.countBoothStaff}","${supplier.countTables}","${supplier.countRegularOutlets}","${supplier.countSpecialOutlets}","${supplier.countDinnerAttendees}","${supplier.comments}","${supplier.invitationCode}"\n`
        }

        let element = document.createElement('a')
        element.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv))
        element.setAttribute('download', 'export.csv')
        element.style.display = 'none'

        document.body.appendChild(element)

        element.click();

        document.body.removeChild(element)
      },
      ...mapActions([
        'deleteSupplier'
      ]),
      openSendDialog(ids, label) {
        this.sendRecipientIds = ids
        this.sendRecipientLabel = label || null
        this.sendDialog = true
      },
      onJobCreated(job) {
        this.$refs.jobProgress.start(job)
      },
      sendIndividualEmailMessage({ id }) {
        const supplier = this.suppliers.find(s => s.id === id)

        this.openSendDialog([ id ], supplier ? `${supplier.companyName} (${supplier.id})` : id)
      }
    },
    name: 'Suppliers'
  }
</script>

<i18n>
  {
    "de": {
      "sendEvaluation": "Zufriedenheits-Umfrage senden",
      "export": "Exportieren…",
      "sendEmail": "E-Mail senden…",
      "import": "Importieren…",
      "inviteAll": "Alle einladen",
      "suppliers": "Lieferanten",
      "remindAll": "Alle erinnern",
      "sendProductImagesMail": "Design-Information senden",
      "sendStartInfo": "Startinformation an Alle senden",
      "sendPhoto": "Foto senden",
      "sendEndReminder": "Enderinnerung an Alle senden",
      "sendProductImagesReminder": "Design-Erinnerung an Alle senden",
      "actions": "Aktionen"
    },
    "en": {
      "sendEvaluation": "Send evaluation",
      "export": "Export…",
      "sendEmail": "Send email…",
      "import": "Import…",
      "inviteAll": "Invite all",
      "suppliers": "Suppliers",
      "remindAll": "Remind all",
      "sendPhoto": "Send photo",
      "sendProductImagesMail": "Send product images mail",
      "sendStartInfo": "Send start info",
      "sendEndReminder": "Send end reminder",
      "sendProductImagesReminder": "Send product images reminder",
      "actions": "Actions"
    }
  }
</i18n>